export default __webpack_public_path__ + "static/media/spendCategoryFeesAndInterest32.f0b6d9db.svg";